<template>
  <div ref="watermark" class="cont">
    <el-breadcrumb separator="/" style="margin-bottom:21px">
      <el-breadcrumb-item :to="{ path: '/' }" style="font-size: 12px;color: #999999 ">首页</el-breadcrumb-item>
      <el-breadcrumb-item v-if="isAside" style="font-size: 12px;color: #666666; ">按车型查询</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/FrameCode' }" class="breadcrumb1" v-if="!isAside"  style="font-size: 12px;color: #666666;"> 按车架号查询</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="main-cont clear" ref='searchMain' >
      <div style="display:flex;align-items:center;margin-bottom: 10px">
        <div style="font-size: 14px;color: #333333;margin-left:100px;width: 100px;">输入车型：</div>
        <div>
          <el-autocomplete :fetch-suggestions="querySearch"  @select="handleSelect"  placeholder="输入您要搜索的车型" v-model="searchValue" class="input-with-select" style="width:600px">
<!--            <el-button slot="append" icon="el-icon-search" @click.stop="searchMt"></el-button>-->
          </el-autocomplete>
        </div>
      </div>

      <!--  -->

      <el-container style="min-height: 1000px; border: 1px solid #eee ;">
        <div class="outer-container" v-if="isAside">
          <div class="inner-container_fixed">
            <div
              :class="[ navItem.title == curItemname ? 'active' : '' ]"
              class="inner-container_item"
              v-for=" ( navItem  ) in city "
              :key='navItem.title'
              @click="branditemClick(navItem.title)"

            >
              {{ navItem.title }}
            </div>
          </div>
          <el-aside width="200px" class="inner-container" style="background-color: rgb(238, 241, 246);font-size:14px;" >
            <el-menu  :unique-opened='false'	:default-openeds="open_list">
              <el-submenu :index="navItem.title"  v-for=" ( navItem  ) in city " :key='navItem.title'
                :data-index='navItem.title'
                class="el-submenu-item"
                :id='navItem.title'
              >
                <template slot="title" > {{ navItem.title }}</template>
                <el-menu-item-group>
                  <el-menu-item
                    :index="brandItem.id.toString()"
                    v-for=" ( brandItem  ) in navItem.item " :key='brandItem.id'
                    style="font-size: 14px;color: #323233;min-width: 130px;padding: 0 15px;height:40px;line-height:40px;cursor : pointer"
                    @click="bindtap( brandItem )"
                  >
                    <el-image
                      style="width: 26px; height: 26px;margin-right:5px"
                      :src=' "https://" + brandItem.logo '
                      fit="contain"
                    ></el-image>
                    {{ brandItem.name }}
                  </el-menu-item>
                </el-menu-item-group>
              </el-submenu>
            </el-menu>
          </el-aside>
        </div>

        <el-container  style="position:relative;display:block">
          <div class="calipersItem1" v-if="calipersItem1Vis">
            <div  v-for=" ( item , idx ) in carType " :key='idx'>
              <div class="title"  >
                {{ item.title }}
                  <div class="line"
                    v-for=" ( type , typeidx ) in item.item " :key='"type" + typeidx'
                    @click="getAutoDetail(type)" style="cursor : pointer;"
                    v-bind:class="{ 'active': type.id == calipersItem1Id  }"
                  >
                    <div > {{ type.name }} </div>

                  </div>
              </div>
            </div>
          </div>

          <div class="calipersItem2" v-show="calipersItem2Vis"   v-if='details.length > 0'>
            <div class="line" v-for=" ( item , idx ) in details " :key='idx'
            @click="searchClick(item)"
            style="cursor : pointer" >
            {{ item.name }}
            </div>
          </div>

          <div style="padding:10px ;color:rgb(127, 127, 127);display:flex;">
            {{ name }}
            <div style="text-align:right;flex:1" v-if="goods.length>0">
              <span style="margin-right:10px;font-size: 14px;color: #333333;">价格开关</span>
              <el-switch  v-model="priceShow"  @change="togglePriceShow"> </el-switch>
              <span style="margin-right:10px;margin-left:20px;font-size: 14px;color: #333333;">现货开关</span>
              <el-switch v-model="goodsShow" @change="toggle"> </el-switch>

            </div>
          </div>

          <div class="tab_cont">
            <el-tabs v-model="currentTab" type="card" >
              <el-tab-pane :label="navItem.name" :name="navItem.categoryId" v-for=" ( navItem  ) in navData " :key='navItem.categoryId'></el-tab-pane>
            </el-tabs>
          </div>

          <div  v-if='goods.length > 0'
            :class="[isAside ? 'item_S' : 'item_L' ]"
            style="padding:20px;box-sizing:border-box"
          >
            <div class="item"  v-for=" ( goodItem , idx ) in goods " :key='idx' @click="gotoDetail(goodItem)"
              style="cursor : pointer"
            >
              <div class="num_cont">
                <el-image
                  v-if="goodItem.amount == 0"
                  style="width: 50px; height: 50px"
                  :src="u189"
                  fit="contain">
                </el-image>
                <el-image
                  v-if="goodItem.amount <= moduleUser.goods_num && goodItem.amount > 0"
                  style="width: 50px; height: 50px"
                  :src=" publicUrl + '/profile/avatar/u188.png' "
                  fit="contain">
                </el-image>
                <el-image
                  v-if="goodItem.amount > moduleUser.goods_num"
                  style="width: 50px; height: 50px"
                  :src=" publicUrl + '/profile/avatar/u187.png' "
                  fit="contain">
                </el-image>
              </div>
              <div>
                <el-image
                  style="width: 200px; height: 200px;margin-top:16px;margin-bottom:10px"
                  class="product_image"
                  :src=' publicUrl + goodItem.apiGoodsSpec.goodsPic '
                  fit="contain"
                ></el-image>
              </div>
              <div class="line line1" style="min-height: 30px">
                <el-image v-if="goodItem.promotionStatus ==1"
                          style="width: 100px; height: 25px" :src=" publicUrl + '/profile/avatar/cxz.png' " fit="contain">
                </el-image>
              </div>
              <div class="line line1" v-if="moduleUser.goods_visible == '1' ">{{ goodItem.goodsName }}
                <span v-if="goodItem.apiGoodsSpec.salesUnit" style="color: red">({{goodItem.apiGoodsSpec.salesUnit}})</span>
              </div>
              <div class="line line1" v-else-if="moduleUser.goods_visible == '0' ">{{ goodItem.goodsErp.specification }}</div>
              <div class="line line2" style="min-height: 64px">
                <span  class="ql-editor" v-html="goodItem.description ? goodItem.description : ''"></span>
              </div>
              <div class='line line2'  @click.stop="goodsStockDetail(goodItem)" style="color: red">查看库存详情>></div>
              <div class='line line3'>
                <div style="color: #7F7F7F;">
                  <div>零售价</div>
                  <div> ¥ {{ goodItem.apiGoodsSpec.goodsPrice }}</div>
                </div>
                <div style="color: #E60012;" v-show="priceShow&&goodItem.promotionStatus ==1">
                  <div style="text-decoration: line-through;">拿货价</div>
                  <div style="text-decoration: line-through;"> ¥ {{goodItem.apiGoodsSpec.discountPrice }}</div>
                </div>
                <div style="color: #E60012;" v-show="priceShow&&goodItem.promotionStatus ==1">
                  <div>活动价</div>
                  <div> ¥ {{goodItem.promotionPrice }}</div>
                </div>
                <div style="color: #E60012;" v-show="priceShow&&goodItem.promotionStatus !=1">
                  <div>拿货价</div>
                  <div> ¥ {{goodItem.apiGoodsSpec.discountPrice }}</div>
                </div>
              </div>
              <div style="display:flex">
                <div
                  class="background_style btn"
                  :style="{backgroundImage: 'url(' + btn_red + ')' }"
                  @click.stop="gotoSettlement(goodItem)"
                  style="cursor : pointer"
                >
                  立即购买
                </div>
                <div
                  class="background_style btn"
                  :style="{backgroundImage: 'url(' + btn_black + ')' }"
                  @click.stop="addCartItem(goodItem)"
                  style="cursor : pointer"
                >
                  加入购物车
                </div>
              </div>
            </div>
          </div>
          <div style="color:gray;padding:30px;text-align:center;width:100%" v-else>
            {{ !name ? '请选择相应车型' : '暂无相关产品，详情请咨询客服' }}
          </div>

        </el-container>
      </el-container>
    </div>

    <AutoParams
      :dialogtitle.sync="dialogtitle"
      :dialogVisible.sync="dialogVisible"
      :curStatus.sync="curStatus"
      :beforeAutoParams.sync="beforeAutoParams"
      :afterAutoParams.sync="afterAutoParams"
      @sendChild1="giveChild1"
      @sendChild2='giveChild2'
      @senddialogVisible ='giveDialogVisible'
    >
    </AutoParams>

    <!-- 搜索框 -->
    <el-dialog
      title="请选择车型排量"
      :visible.sync="searchVisible"
      width="500"
      center
    >
      <div style="height:400px;overflow-y:scroll">
        <div  v-for=" ( item  ) in plList "
          :key='item.key'
          style="margin-bottom:15px;font-size:16px;cursor : pointer;;color:blue"
          @click.stop="searchPlClick(item)"
        >
        {{plName}}-{{ item.name }}
        </div>
      </div>

      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="searchVisible = false">取 消</el-button>
        <el-button type="primary" @click="searchVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>

    <div style="text-align:center;margin-top:20px">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total">
      </el-pagination>
    </div>


    <el-dialog title="" :visible.sync="showFlag" width="650px" center  :show-close='false'
               :close-on-press-escape='false' :close-on-click-modal ='false' >
      <div style="width:100%;margin-bottom:10px;text-align: center">
        <div style="text-align: center;font-size: 20px;font-weight: bold;margin-bottom: 60px">{{goodsName}}</div>
        <div style="margin-bottom: 100px">
          <div v-for=" ( detail , idx ) in stockDetail " :key='idx' style="text-align: center;  width: 100%;   margin-left: 33%;margin-bottom: 20px">
            <div  class="background_style btn"  :style="{backgroundImage: 'url(' + u35 + ')' }" style="text-align: center;width: 200px" >
              <div v-if='detail.showFlag == "0"'>
                {{detail.subWarehouseName}} :
                <span  v-if='detail.quantity > moduleUser.goods_num'>现货充足</span>
                <span  v-else-if='detail.quantity <= moduleUser.goods_num && detail.quantity > 0' >少量现货</span>
                <span v-else-if= 'detail.quantity == 0'  >可以预定</span>
              </div>
              <div v-else-if='detail.showFlag == "1"'>
                {{detail.subWarehouseName}} :
                <span  v-if='detail.quantity > moduleUser.goods_num'>现货充足</span>
                <span  v-else>{{  detail.quantity }}</span>
              </div>
            </div>
          </div>
          <div   style="text-align: center;  width: 100%;   margin-left: 33%;margin-bottom: 20px">
            <div   class="background_style btn"  :style="{backgroundImage: 'url(' + u35 + ')' }" style="text-align: center;width: 200px" >
              在途数 :{{transitQuantity}}
            </div>
          </div>
        </div>
      </div>
      <div style="display:flex;justify-content:center">
        <div class="background_style btn"  :style="{backgroundImage: 'url(' + btn_red + ')' }"
             style="cursor : pointer"  @click="stockDetailCancel" >
          关闭
        </div>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import {
  getAllAutoBrandReq ,
  getAutoSelectByBrandReq  ,
  getAutoDetailReq ,
  getChooseAutoParamByAutoReq ,
  getItemsReq ,
  getCategoryListByModelReq ,
  getGoodsListByModelReq ,
  addCartItemReq ,
  getAutoFuzzyQueryReq,getStockDetail, getTextListReq
} from "@/api/productList/productList";
import AutoParams from '@/components/component/AutoParamsComponents/AutoParams'
import watermark from '@/utils/waterMark'

export default {
  components: { AutoParams },
  comments:watermark,
  data(){
    return {
      showFlag : false ,
      stockDetail:[],
      transitQuantity:0,
      goodsName:'',
      publicUrl : this.common.publicUrl ,
      u35 : this.common.publicUrl + '/profile/avatar/u35.png' ,
      btn_red : this.common.publicUrl + '/profile/avatar/u146.png' ,
      btn_black : this.common.publicUrl + '/profile/avatar/u147.png' ,
      u189 :  this.common.publicUrl + ( this.$store.state.moduleUser.discount_status=='Y'?'/profile/avatar/u189.png':'/profile/avatar/u190.png') ,
      name : '' ,//显示名称
      input3 : ''  ,
      pageNum : 1 , //当前页数
      pageSize : 20 , //每页条数
      total : 0 ,
      goods : []  ,  //产品列表
      city : [] ,    //品牌数据
      calipersItem1Vis : false , //选项1
      calipersItem2Vis : false , //选项2
      carType : []  ,     //车型1
      carBrandName : '' ,
      open_list : ['A' , 'B' , 'C' , 'D' , 'E' , 'F' , 'G' , 'H' ,'I' , 'J' ,'K' , 'L' ,'M' , 'N' , 'O' , 'P' ,'Q' , 'R' , 'S' , 'T' ,'U' , 'V' ,'W' ,'X' ,'Y' ,'Z'] ,
      details : [] , //具体车型
      plList : [] , //具体车型
      plName :"" , //具体车型
      visible : false ,
      searchVisible : false ,  //查找框
      searchValue : '' , //搜索值
      searchType : '' ,
      cjmlFuzzy : [] , //搜索值
      isAside : true , //侧边栏存在
      curStatus : 1 ,  //当前状态
      afterAutoParams : [] , //前卡钳
      beforeAutoParams : [] , //后卡钳
      dialogtitle : '' , //弹框标题
      dialogVisible : false , //弹框显隐
      query : '' ,
      beforeParamValueId : '' ,
      beforeParamTypeId : '' ,
      currentTab : '' ,
      currentName: '' ,
      navData : [] , //tab数据
      itemCode : '' ,
      aliasCodes : [] ,
      partNames : [] ,
      vin : null,
      priceShow : true , //价格显示开关
      goodsShow : false , //价格显示开关
      calipersItem1Id : ''  ,
      curItemname : '' , //当前选中的索引信息
    }
  } ,

  computed : {
    moduleUser() {
      return this.$store.state.moduleUser; // 这里返回的是：{name: 'wang', age: 22}
    }  ,
  },
  activated() {
    let  dealerName =window.localStorage.dealerName
    let  username =window.localStorage.username
    let text =dealerName+username.substring(username.length-4,username.length)
    watermark.set(text,this.$refs.watermark);
    // console.log( this.$route )
    if( this.$route.meta.ifDoFresh ){ //需要刷新
      this.name = ''
      this.isAside = true
      this.query = ''
      this.beforeParamValueId = ''
      this.beforeParamTypeId = ''
      this.afterParamValueId = ''
      this.afterParamTypeId = ''
      this.goods = []
      this.pageNum = 1
      this.navData = []
    }
    if( this.$route.params.obj ){
      // 从车架号跳转来
      if( this.$route.params.obj.type == 3 ){
        this.name = ''
        this.isAside = false
        this.query = this.$route.params.obj.query
        this.beforeParamValueId = ''
        this.beforeParamTypeId = ''
        this.afterParamValueId = ''
        this.afterParamTypeId = ''
        this.calipersItem1Vis = false  //选项1
        this.calipersItem2Vis = false  //选项2
        this.calipersItem1Id = ''
        this.searchType = 1
        this.itemCode = this.$route.params.obj.itemCode
        this.aliasCodes =  this.$route.params.obj.aliasCodes
        this.partNames =  this.$route.params.obj.partNames
        this.vin = this.$route.params.obj.query
        this.name =  this.$route.params.obj.name
        this.beforeParamValue =  this.$route.params.obj.beforeParamValue
        this.afterParamValue =  this.$route.params.obj.afterParamValue
        this.getCategoryListByModel()
      }
    }else{
      this.vin = null
      this.searchType = 2
    }
    this.$nextTick(()=>{
      console.log(window.localStorage.priceShow==0?true:false)
      this.priceShow = window.localStorage.priceShow==0?true:false;
    })
  },
  created(){
    this.goods = []
    this.pageNum = 1
    this.getAllAutoBrand()
    this.getTextList()

    // console.log( this.$route.params.obj )


  },
  methods : {

    getTextList(){
      getTextListReq({
        searchType:2 ,
      }).then( res => {
        if (res.data.status == 0) {
          let texts = res.data.texts;
          this.restaurants = []
          for(let i =0;i<texts.length;i++){
            this.restaurants.push( {"value":texts[i].text,item:texts[i]})
          }
        } else {
          this.$message.error(res.data.statusDesc);
        }
      })
    },
    querySearch(queryString, cb) {

      let results=[];
      if(queryString.length==0){
        let restaurants = this.restaurants;
        results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      }else{
        getAutoFuzzyQueryReq({
          query : queryString
        }).then( res => {
          if (res.data.status == 0) {
            this.cjmlFuzzy = res.data.cjmlFuzzy
            for(let i =0;i<this.cjmlFuzzy.length;i++){
              results.push( {"value":this.cjmlFuzzy[i].brandName+this.cjmlFuzzy[i].modelName+this.cjmlFuzzy[i].seriesName,item1:this.cjmlFuzzy[i]})
            }
            cb(results);
          }
        })
      }

    },
    handleSelect(row){

      if(row.item!=null){
        let item ={name:row.item.text,key:row.item.subId}
        this.searchClick(item)
      }else if(row.item1!=null){
        let item ={id:row.item1.modelId,signal:4}
        getAutoDetailReq({
          signal : item.signal ,
          id : item.id ,
        }).then( res => {
          if (res.data.status == 0) {
            this.plList = res.data.details
            this.plName = row.item1.modelName
            this.searchVisible = true
          }else{
            this.$message.error(res.data.statusDesc);
          }
        })

      }
    },
    searchPlClick(row){
      this.searchVisible = false
      let item ={name:this.plName,key:row.key}
      this.searchClick(item)
    },
    createFilter(queryString) {

      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf("") === 0);
      };
    },
    togglePriceShow(){
      window.localStorage["priceShow"] =this.priceShow?"0":"1";
    },
    toggle(){
      this.pageNum = 1
      this.getGoodsListByModel();
    },
    // 获取所以品牌
    getAllAutoBrand(){

      getAllAutoBrandReq(  ).then( res => {
        if (res.data.status == 0) {
          this.city = JSON.parse( res.data.cjmlBrands )
        }else{
          this.$message.error(res.data.statusDesc);
        }
      })
    } ,
    bindtap( brandItem ){ //根据品牌查询明细
      // console.log( brandItem )
      this.getAutoSelectByBrand( brandItem.id  , brandItem.name )
    } ,
    //根据品牌查询明细
    getAutoSelectByBrand( id , name ){
      // const loading = this.$loading({
      //   lock: true,
      //   text: 'Loading',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0)'
      // })
      getAutoSelectByBrandReq( {
        id : id  ,
        name : name ,
      } ).then( (res)=>{
        // loading.close();
        if (res.data.status == 0) {
          this.carType =  JSON.parse( res.data.brandDetails )
          this.carBrandName = res.data.name
          this.calipersItem1Vis = true
          this.calipersItem2Vis = false
          this.details = []
          if( !this.visible ){
            this.togglePanel()
          }

        }else{
          this.$message.error(res.data.statusDesc);
        }
      } )
    },
    //选择车型2
    getAutoDetail( item ){
      // const loading = this.$loading({
      //   lock: true,
      //   text: 'Loading',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0)'
      // });
      this.calipersItem1Id = item.id
      getAutoDetailReq({
        signal : item.signal ,
        id : item.id ,
      }).then( res => {
        // loading.close();
        if (res.data.status == 0) {

          this.details = res.data.details
          this.calipersItem2Vis = true
        }else{
          this.$message.error(res.data.statusDesc);
        }
      })
    },
    //点击查询
    searchClick( item ){
      // const loading = this.$loading({
      //   lock: true,
      //   text: 'Loading',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0)'
      // });

      this.query = item.key
      getChooseAutoParamByAutoReq({
        type : 0 ,
        signal : 5 ,
        query : item.key ,
      }).then( res => {
        // loading.close();
        this.name = item.name
        if( res.data.afterAutoParams.length > 0  || res.data.beforeAutoParams.length > 0 ) {  //存在前后刹车类型
          if( res.data.beforeAutoParams.length > 0 ){  //前面的有
            this.curStatus = 1
            this.dialogtitle = '请选择前卡钳类型'
            this.afterAutoParams = res.data.afterAutoParams
            this.beforeAutoParams = res.data.beforeAutoParams
          } else if( res.data.afterAutoParams.length > 0  ){ //后面的有
            this.curStatus = 2
            this.dialogtitle = '请选择后卡钳类型'
            this.afterAutoParams = res.data.afterAutoParams
            this.beforeAutoParams = res.data.beforeAutoParams
          }
          this.dialogVisible = true
        } else { //不存在刹车类型
          this.getItems(5)
        }
      })
    } ,
    searchMt(){
      if( !this.searchValue ){
        this.$message({
          message: '请输入搜索关键字',
          type: 'warning'
        });
        return
      }
      this.cjmlFuzzy = []
      this.getAutoFuzzyQuery()
    },
    //点击搜索项
    searchItemClick( item ){
      this.query = item.modelId
      this.name = item.brandName + '-' + item.areaName  + '-' + item.modelName
      this.searchVisible = false
      this.getItems(4)
    },
    getAutoFuzzyQuery(){
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0)'
      });
      getAutoFuzzyQueryReq({
        query : this.searchValue
      }).then( res => {
        loading.close()
        if (res.data.status == 0) {
          this.cjmlFuzzy = res.data.cjmlFuzzy
          this.searchVisible = true
        }
      } )
    },

    //接受数据
    giveChild1(data){
      // if( data.beforeParamTypeId ){
      //   this.beforeParamTypeId = data.beforeParamTypeId
      //   this.beforeParamValueId = data.beforeParamValueId
      // }else if( data.getItems ){
      //   this.dialogVisible = false
      //   this.getItems(5)
      // }


      if( data.beforeParamTypeId ){
        this.beforeParamTypeId = data.beforeParamTypeId
        this.beforeParamValueId = data.beforeParamValueId
        this.beforeParamValue = data.beforeParamValue
      }
      if( data.getItems ){
        this.dialogVisible = false
        this.getItems(5)
      }
    },
    giveChild2(data){
      this.afterParamTypeId = data.afterParamTypeId
      this.afterParamValueId = data.afterParamValueId
      this.afterParamValue = data.afterParamValue
      this.dialogVisible = false
      this.getItems( 5 )
    },
    giveDialogVisible(){
      this.dialogVisible = false
    },
    //接受数据

    //获取品项
    getItems( signal , type ){
      const loading = this.$loading({
        // lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0)'
      });
      getItemsReq({
        type :  type ? type : 0 ,
        signal : signal ,
        query : this.query ,
        beforeParamValueId : this.beforeParamValueId ?  this.beforeParamValueId : '' ,
        beforeParamValue : this.beforeParamValue ?  this.beforeParamValue : '' ,
        beforeParamTypeId : this.beforeParamTypeId ? this.beforeParamTypeId : '' ,
        afterParamValueId : this.afterParamValueId ? this.afterParamValueId : '',
        afterParamValue : this.afterParamValue ? this.afterParamValue: '',
        afterParamTypeId : this.afterParamTypeId ? this.afterParamTypeId : '',
      }).then( res => {
        loading.close();
        this.getTextList();
        this.beforeParamValueId = ''
        this.beforeParamTypeId =  ''
        this.afterParamValueId = ''
        this.afterParamTypeId = ''
        this.calipersItem1Vis = false  //选项1
        this.calipersItem2Vis = false  //选项2
        this.calipersItem1Id = ''
        if( res.data.status == 0 ){
          this.itemCode = res.data.itemCode ? res.data.itemCode : ''
          this.aliasCodes =  res.data.aliasCodes ?  res.data.aliasCodes : []
          this.partNames =  res.data.partNames ?  res.data.partNames : []
          this.vin = ''
          if( res.data.text ){
            this.name = res.data.text
          }
          this.getCategoryListByModel( )
        }


      } )
      .catch(error => {
        // console.log( error )
      });
    } ,
    //从车型页面获取分类信息
    getCategoryListByModel(  ){
      getCategoryListByModelReq({
        itemCodes : this.itemCode
      }).then( res => {
        if( res.data.status == 0 ){
          this.navData = res.data.category
          if( this.navData.length > 0 ){
            this.currentTab = this.navData[0].categoryId //当前默认第一项
            this.currentName = this.navData[0].name //当前默认第一项
            this.getGoodsListByModel()

          }
        }
      })
    },
    //从车型页面获取商品信息
    getGoodsListByModel(){
      const loading = this.$loading({
        // lock: true,
        text: '拼命加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0)'
      });
        for(let i =0;i<this.navData.length;i++){
          if(this.navData[i].categoryId ==this.currentTab){
            this.currentName = this.navData[i].name
          }
        }

      getGoodsListByModelReq({
        itemCodes : this.itemCode ,
        categoryId : this.currentTab ,
        pageNum : this.pageNum ,
        goodsNumFlag : this.goodsShow   ,
        pageSize : this.pageSize
      }).then( res => {
        loading.close()
        res.data.goods.forEach(  (val ) => {
          let itemCodeArr = []
          this.aliasCodes.forEach( (  v ) => {
            if( v.itemCode == val.goodsErp.drawingNumber ){
              itemCodeArr.push( v.aliasCode )
            }
          })

          this.partNames.forEach((  v , i) => {
            if(v.itemCode==val.goodsErp.drawingNumber&&this.currentTab==9){
              val.description= v.partName
            }
          })

          if( itemCodeArr.length > 0 ){
            val.goodsErp.itemCode = itemCodeArr.join( ',' )
          }
        })
        this.goods = res.data.goods ;
        this.total = res.data.total
      })
    },

    // 点击空白区域关闭某个div图层
    togglePanel () {
      this.visible ? this.hide() : this.show()
    },

    // 点击空白处关闭
    show () {
      this.visible = true
      document.addEventListener('click', this.hidePanel, false)
    },
    hide () {
      this.visible = false
      this.calipersItem1Vis = false ;
      this.calipersItem2Vis = false ;
      document.removeEventListener('click', this.hidePanel, false)
    },

    hidePanel (e) {
      if( this.$refs.searchMain ){
        if ( !this.$refs.searchMain.contains(e.target)  ) {
          this.hide()
        }
      }
    } ,
    // 点击空白处关闭
    //加入购物车
    addCartItem( goodItem ){
      let curGoodsInfo = goodItem
      addCartItemReq({
        goodsId : curGoodsInfo.goodsId ,
        goodsName : curGoodsInfo.goodsName ,
        jancode : curGoodsInfo.apiGoodsSpec.jancode ,
        goodsSpecId : curGoodsInfo.apiGoodsSpec.goodsSpecId ,
        quantity : 1 ,
        goodsPic : curGoodsInfo.apiGoodsSpec.goodsPic ,
        subTitle : curGoodsInfo.subTitle? curGoodsInfo.subTitle : '' ,
        specSkuId : curGoodsInfo.apiGoodsSpec.specSkuId ,
        sukSpec  : curGoodsInfo.apiGoodsSpec.sukSpec ,
        vin : this.vin ,
        beforeParamValue: this.beforeParamValue,
        afterParamValue: this.afterParamValue,
        searchValue : this.name +this.currentName,
        searchType : this.searchType ,
        description : curGoodsInfo.description
      }).then( res => {
        if (res.data.status == 0) {
          this.$message({
            message: '添加成功',
            type: 'success'
          });
          this.$store.commit('cart_refresh_open');
        } else {
          this.$message.error(res.data.statusDesc);
        }
      })
    },
    // 去结算页面
    gotoSettlement( goodItem ){
      let item = goodItem
      let apiTempOrder = []
      apiTempOrder.push({
        goodsId : item.goodsId ,
        jancode : item.apiGoodsSpec.jancode ,
        vin : this.vin ,
        beforeParamValue: this.beforeParamValue,
        afterParamValue: this.afterParamValue,
        searchValue : this.name +this.currentName,
        quantity : 1 ,
      })
      if( apiTempOrder.length <= 0 ){
        this.$message('暂时不能购买');
        return
      }
      this.$store.commit('cart_refresh_open');
      apiTempOrder =  JSON.stringify( apiTempOrder )
      this.$router.push({
        path: '/splitOrder',
        query: {
          apiTempOrder : apiTempOrder ,
          isCartItem : 0 ,
        }
      })
    },
    //点击跳转详情页
    gotoDetail( goodItem ){
      let goodsId = goodItem.goodsId
      let jancode = goodItem.apiGoodsSpec.jancode
      this.$router.push({
        path: '/goodDetail',
        query: {
          goodsId: goodsId ,
          jancode : jancode,
          searchType : this.searchType,
          searchValue : this.name +this.currentName,
          beforeParamValue: this.beforeParamValue,
          afterParamValue: this.afterParamValue,
        }
      })
      // let routeData = this.$router.resolve({
      //   path: '/goodDetail',
      //   query: {
      //     goodsId: goodsId ,
      //     jancode : jancode
      //   }
      // });
      // window.open(routeData.href, '_blank');
    } ,
    //字母跳转
    branditemClick( name ){
      this.curItemname = name
      document.querySelector(`#${name}`).scrollIntoView({block: "start"})
      window.scrollTo(0 , 0)

    }, // 库存详情
    goodsStockDetail( goodItem ){
      let item = goodItem
      this.goodsName =item.goodsName
      this.stockDetail= [];
      getStockDetail({
        jancode:item.apiGoodsSpec.jancode ,

      }).then( res => {
        if (res.data.status == 0) {
          this.showFlag = true;
          this.stockDetail = res.data.stockDetail;
          this.transitQuantity = res.data.transitQuantity;
        } else {
          this.$message.error(res.data.statusDesc);

        }
      })

    }
    ,stockDetailCancel(){
      this.showFlag = false;
    }

  },
  watch: {
    // 如果 `question` 发生改变，这个函数就会运行
    currentTab: function ( ) {
      this.getGoodsListByModel()
    }
  },
}
</script>


<style lang="stylus" scoped>
.cont {
  width: 1200px;
  color: #000;
  margin: 0 auto;
  box-sizing: border-box;
  padding : 20px 0
}
.el-header {
  background-color: #B3C0D1;
  color: #333;
  line-height: 60px;
}

.el-aside {
  color: #333;
}

.input-with-select >>> .el-input__inner{
  border-radius: 20px 0 0 20px;
}
.input-with-select >>> .el-input-group__append{
  background-color #fff
  border-radius: 0 20px 20px 0;
}
  .breadcrumb1 :hover {
    color :red  !important;
    cursor: pointer !important;
  }

.main-cont {
  background-color: #fff;
  padding 24px
}

.calipersItem1
  position:absolute;
  left: 0;
  top:0;
  width:311px;
  z-index:1000;
  background-color:#fafafa;
  box-shadow: rgba(0, 0, 0, 0.35) 5px 5px 5px 0px;
  border-right: 1px solid  #969696
  box-sizing border-box
  max-height 500px
  overflow-y : auto
  .title
    line-height 47px;
    font-size: 14px;
    font-weight: 700;
    color: #323233;
    text-indent 10px
  .line
    line-height 20px;
    padding: 15px
    font-size: 14px;
    font-weight: 400;
    color: #323233;
    background-color #fff
    border-left : 4px solid #fff
  .line:hover
    background-color #ffe5e5
  .line.active
    border-left : 4px solid #f90000

.calipersItem2
  position:absolute;
  left: 312px;
  top:0;
  width:281px;
  z-index:1000;
  background-color:#fafafa;
  box-shadow: rgba(0, 0, 0, 0.35) 5px 5px 5px 0px;
  max-height 500px
  overflow-y : auto
  .line
    line-height 20px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.4);
    padding: 15px
    box-sizing: border-box
  .line:hover
    background-color #ffe5e5

.outer-container{
	width: 183px;
	min-height: 498px;
	position: relative;
	overflow: hidden;
  background-color:#fafafa;
  border-right: 1px solid  #eee
}
.inner-container{
	position: absolute;
	left: 0;
	top: 200px;
	right: -17px;
	bottom: 0;
	overflow-x: hidden;
	overflow-y: scroll;
}
.inner-container_fixed{
  // position: absolute;
	// left: 0;
	// top: 0;
  height:200px;
  width :183px;
  z-index :100;
  padding:10px;
  box-sizing:border-box;
  display:flex;
  flex-wrap : wrap;
  background-color:#eef1f7
}
.inner-container_item {
  height:25px;
  line-height:25px;
  width:25px;
  margin-right:7px;
  margin-bottom:8px;
  background-color: #fff;
  border:1px solid #f90000;
  color:#f90000;
  text-align:center;
  cursor:pointer;
  box-sizing:border-box
}
.inner-container_item.active{
  background-color: #f90000;
  color:#fff
}

.tab_cont >>> .el-tabs__nav-scroll {
  background-color:#f2f2f2
}
.tab_cont >>> .el-tabs__item.is-top {
  font-size: 14px;
}

.main-cont >>> .el-menu-item.is-active {
  border-left : 4px solid #f90000
}
.main-cont >>> .el-menu-item {
  border-left : 4px solid #fff
}
.main-cont >>>  .el-loading-spinner {
  font-size: 35px
}
  .item {
    width: 230px;
    height: 480px;
    float: left;
    text-align: center;
    margin-right 50px
    margin-bottom 20px
    border: 1px solid rgb(242, 242, 242);
    box-sizing border-box;
    position:relative
  }
    .num_cont{
      position absolute;
      right:0;
      top:0;
      height:50px;
      width:50px;
      z-index : 999;
    }
    .line{
      overflow:hidden; //超出的文本隐藏
      text-overflow:ellipsis; //溢出用省略号显示
      white-space:nowrap; //溢出不换行
      padding : 0 10px ;
      box-sizing border-box
    }
    .line1{
      font-size: 12px;
      color: #333333;
      margin-bottom 7px
    }
    .line2{
      font-size: 12px;
      margin-bottom 12px;
      white-space: pre-wrap;

    }
    .line3{
      font-size: 14px;
      font-weight: 400;
      color: #F04844;
      margin-bottom 19px
      display : flex
      justify-content: space-around
    }

.item_L
  width:100%
  .item:nth-child(4n + 4) {
    margin-right 0
  }
.item_S
  width: 966px
  .item:nth-child(3n + 3) {
    margin-right 0
  }
</style>
